import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

/**
 * Native port of the v1 `RateCodes` factory (account-v1/src/core/api/
 * rateCodes.js). WS5 #10 Stage A inc 2x: replaces the
 * `$injector.get('RateCodes')` grab in ft-touchpoint-integration (the
 * excluded-reservation-types editor). `getRateCodes` resolves the BODY (v1
 * `.then(r => r.data)`); `updateRateCodes` is the consumer's fire-and-forget
 * save (firstValueFrom fires the cold HttpClient observable like v1 $http).
 */
@Injectable({ providedIn: 'root' })
export class RateCodesV1ApiService {
  private readonly http = inject(HttpClient);

  /** v1 `RateCodes.getRateCodes(propertyUUID)`. */
  getRateCodes(propertyUUID: string): Promise<any> {
    return firstValueFrom(this.http.get('/api/v2/' + propertyUUID + '/properties/' + propertyUUID + '/reservation/exclusions'));
  }

  /** v1 `RateCodes.updateRateCodes(propertyUUID, rateCodes)`. */
  updateRateCodes(propertyUUID: string, rateCodes: any): Promise<any> {
    return firstValueFrom(this.http.put('/api/v2/' + propertyUUID + '/properties/' + propertyUUID + '/reservation/exclusions', rateCodes));
  }
}
